export { TimsRewardsPoints } from './tims-rewards-points';
